<template>
<div class="chapter">
<div class="inner_page">
<div class="didbox">
<p class="h1fm">Dedication</p>
<p class="did">To my grandchildren, who are always happily in my thoughts while I happily stitch</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?947cd69c